import { useEffect, useRef } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { PAYMENT_LINK } from "@zenith/routes/paths";

export const usePaymentLinkOperationId = () => {
  const { operationId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const hasRecoveredRef = useRef(false);

  useEffect(() => {
    if (operationId) {
      sessionStorage.setItem("paymentLinkCurrentOpId", operationId);
      localStorage.setItem("paymentLinkLastOpId", operationId);
      hasRecoveredRef.current = false;
    }
  }, [operationId]);

  useEffect(() => {
    if (hasRecoveredRef.current) return;

    const isPaymentLinkPage = location.pathname.includes("/payment-link");

    if (isPaymentLinkPage) {
      const pathParts = location.pathname.split("/");
      const hasOperationIdInPath = pathParts.length >= 3 && pathParts[2] !== "";

      if (!hasOperationIdInPath) {
        const storedOpId =
          sessionStorage.getItem("paymentLinkCurrentOpId") ||
          localStorage.getItem("paymentLinkLastOpId");

        if (
          storedOpId &&
          storedOpId !== "cfe5f4e9-3a7d-41c1-85dc-1235464ee073"
        ) {
          hasRecoveredRef.current = true;

          const additionalPath = pathParts.slice(2).join("/");
          const newPath = `${PAYMENT_LINK}${storedOpId}${
            additionalPath ? `/${additionalPath}` : ""
          }${location.search}`;

          navigate(newPath, { replace: true });
        }
      }
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    return () => {
      const isLeavingPaymentFlow =
        !window.location.pathname.includes("/payment-link");
      if (isLeavingPaymentFlow) {
        sessionStorage.removeItem("paymentLinkCurrentOpId");
      }
    };
  }, []);

  return operationId;
};
